module.exports = __webpack_public_path__ + "img/cloth_g1_hat_02.70946505.svg";